import { UserService } from 'src/app/service/userservice';
import { Component, OnInit ,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountUserService } from '../service/account.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from '../app-main.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { CookieStoreService } from '../modules/shared/services/cookie-store.service';
import { COOKIE_NAMES } from '../modules/shared/constants/cookies-names.constant';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { verifyOrganizationLoginDetails, verifyOrganizationLoginDetailsResponse } from './models/authenticatonSetup.models';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit ,AfterViewInit{
    assestBaseUrl: string = environment.assestsBasePath;
    userIP: string;
    form: FormGroup;
    loading = false;
    submitted = false;
    returnUrl = "";
    encryptSecretKey = "LionO3602.0CRM2021";
    lat = 0;
    lng = 0;
    userAddress: string = "";

    showPassword: boolean = false;
    showEyeIcon: boolean = false;
    loginFormData :any ;

    public isShowSpinner: boolean;
    showOrg:boolean = true;

    //login Authenticator
    verification: string;
    pageLogin: boolean  = false;
    authenticationSetup: boolean = false
    authenticationPage = false;
    displayAuthentication = false;
    displaySMS = false;
    displayEmail = false;
    authenLayer = 1;
    smsLayer = 1;
    emailLayer = 1;
    verificationCode: number;
    authenticationData:any

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();
    initialLoginSetup: FormGroup = new FormGroup({});
    verifyOrgCodeResponse: any;

    constructor(private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private accountService: AccountUserService,
        private userService: UserService,
        private messageService: MessageService,
        public appMainService: AppMainService,
        private cookieStoreService: CookieStoreService,
        private confirmationService: ConfirmationService) {
    }
    ngAfterViewInit(): void {
        this.checkSessionValid();
    }

  ngOnInit(): void {
    this.initialLoginForm();
    this.form = this.formBuilder.group({
      orgCode: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false,]
    });
    this.userIP = '142.250.217.100';
    let routeValue = this.route.snapshot.queryParams;
    this.returnUrl = routeValue?.returnUrl || null;
      this.accountService.getIPAddress().subscribe((res:any)=>{
        this.userIP = res && res.ip ? res.ip : '142.250.217.100';
      },
      err=>{
        this.userIP = '142.250.217.100';
      },
      ()=>{
      });

        this.appMainService.showSpinner
            .pipe(distinctUntilChanged())
            .subscribe((data) => {
                setTimeout(() => {
                    this.isShowSpinner = data
                }, 10);
            });

        this.getUserLocation();
        const rememberedEmailID = this.cookieStoreService.getEnCookie(COOKIE_NAMES.emailId);

        if (rememberedEmailID) {
            // Populate the username field
            this.form.patchValue({ username: rememberedEmailID });

            // Check the "Remember Me" checkbox
            this.form.patchValue({ rememberMe: true });
        }
    }

    checkSessionValid(){
        if(localStorage.getItem('sessionExpired') == 'sessionInvalid'){
            this.messageService.add({
                severity: 'warn',
                summary: 'Session Expired',
                detail: 'Your session has been expired because your account was accessed from another browser or device.'
            });
            localStorage.removeItem('sessionExpired');
        }
    }

    getUserLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.lat = position.coords.latitude;
                this.lng = position.coords.longitude;

                this.userService.getAddressByLatLng(this.lat, this.lng).then(response => {
                    if (response?.results?.length > 0) {
                        let address = response.results[0].formatted_address;
                        this.userAddress = address;
                    }
                });

            });
        } else {
        }
    }

    get f() { return this.form.controls; }

    encryptData(msg) {
        var keySize = 256;
        var salt = CryptoJS.lib.WordArray.random(16);
        var key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
            keySize: keySize / 32,
            iterations: 100
        });

        var iv = CryptoJS.lib.WordArray.random(128 / 8);

        var encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

        return result;
    }

    onSubmit(checkSession: boolean = true) {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        let randomstr = this.getRandomString(5);
        localStorage.setItem("randomstr", randomstr);
        const remberAuthenKey = this.cookieStoreService.getDecryptedBypassAuthenticationData();
        let existingDataInCookies: any;
        if(remberAuthenKey){
             existingDataInCookies = remberAuthenKey.find(email=>email.emailId === this.f.username.value.toLowerCase());
        }


        let userDetail = {
            emailId: this.f.username.value.toLowerCase(),
            password: this.encryptData(this.f.password.value),
            userSource: this.userIP,
            sourceType: "Web",
            sessionId: randomstr,
            userIP: this.userIP,
            latitude: `${this.lat}`,
            longitude: `${this.lng}`,
            address: (this.userAddress ? this.userAddress : ""),
            isRememberKey: existingDataInCookies?.isRememberKey,
            OrgCode : this.verifyOrgCodeResponse?.orgCode
        }

       this.loginFormData = {
        rememberMe: this.form.get('rememberMe').value,
        emailId:  this.form.get('username').value
       }

       if(checkSession){
            this.checkUserSession(userDetail);
        }else{
            this.setupAuthentication(userDetail);
        }
    }

    showError(msg) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
    }

    getRandomString(length: number): string {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      }

    onPasswordInput() {
        this.showEyeIcon = true;
        const passwordInput = this.form.get('password');
        if (passwordInput.value && passwordInput.value.length > 0) {
          this.showPassword = false;
        } else{
            this.showEyeIcon = false;
        }
    }

    //#region setup Authentication or verify type of Authentication
    sessionClearConfirmation(loginDetails:any) {
        this.confirmationService.confirm({
            message: 'It looks like you are already signed in on another device. Would you like to log out from the previous session and continue here?',
            header: 'Active Session Detected',
            icon: 'pi pi-info-circle',
            key: 'confirm-session-clear',
            accept: () => {
                this.setupAuthentication(loginDetails);
            },
            reject: () => { }
        });
    }

    checkUserSession(loginDetails:any){
        this.appMainService.isShowSpinner('checkUserSession');
        this.accountService.checkUserSession(loginDetails)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response: any) => {
                        this.appMainService.isHideSpinner('checkUserSession');
                        if(response?.isSuccess){
                            if(response?.isMultipleLogin){
                                this.sessionClearConfirmation(loginDetails);
                            }else{
                                this.setupAuthentication(loginDetails);
                            }
                        }else{
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: response?.message||'Password is invalid, please check...'
                            });
                        }
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('checkUserSession');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Authentcation  details are not loaded, please try again...'
                        });

                    },
                    complete: () => {
                    },
                });
    }

    setupAuthentication(loginDetails:any){
        this.appMainService.isShowSpinner('authentication');
        this.accountService.authenticationSetup(loginDetails)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        const authenData:any = response;
                                this.authenticationData = authenData;
                                this.pageLogin = false;
                                this.authenticationSetup = true;
                        this.appMainService.isHideSpinner('authentication');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('authentication');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Authentcation  details are not loaded, please try again...'
                        });

                    },
                    complete: () => {
                    },
                });
    }


    //#endregion

    //#region onAuthentication back clicked
    onAuthenticationSetupBackClicked() {
        this.authenticationSetup = false;
        this.pageLogin = true;
    }

    onSubmitAuthenPage(enteredCode:number){

    }

    onReSetupAuthen(eventData:any){
        if (eventData.success && eventData?.output?.toLowerCase() === "submit") {
            this.pageLogin = true;
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: `Authentication Re-Set Successfully`,
              });
          }else{
            this.pageLogin = true;
          }
    }

    initialLoginForm() {
          this.initialLoginSetup = this.formBuilder.group({
            organizationCode: [null, Validators.required],
            emailId: [null, [Validators.required, Validators.email]],
            rememberMe: [false]
          });

          this.setCookiesDetails();
    }

    onInitialLoginSetupSubmit() {
        if (this.initialLoginSetup.invalid) {
            return;
        }
        const loginDetails = this.initialLoginSetup.getRawValue();
        const  loginDetailsPayload : verifyOrganizationLoginDetails =  {
            emailId: loginDetails.emailId,
            orgCode:  loginDetails.organizationCode,
        }
        this.appMainService.isShowSpinner('verifyOrgCode');
        this.accountService.verifyOrgLoginDetails(loginDetailsPayload)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
            {
            next: (response : verifyOrganizationLoginDetailsResponse) => {
                        this.verifyOrgCodeResponse = response;
                        this.showOrg = false;
                        this.pageLogin = true;
                        // In your component
                        if (loginDetails.rememberMe) {
                            const userData = {
                            emailId: loginDetails.emailId,
                            organizationId: loginDetails.organizationCode
                            };

                            // Set both values in a single cookie in encrypted form
                            this.cookieStoreService.setRememberMeUserOrgDetails(userData);
                        } else {
                            // If the checkbox is unchecked, remove the cookie
                            this.cookieStoreService.deleteRememberMeUserOrgDetails();
                        }
                        this.setLoginDetails(this.verifyOrgCodeResponse);
                this.appMainService.isHideSpinner('verifyOrgCode');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('verifyOrgCode');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Something went wrong, please try again...'
                });

            },
            complete: () => {
            },
        });
    }

    setLoginDetails(loginDetails: verifyOrganizationLoginDetailsResponse) {
        this.form.patchValue({
            username: loginDetails.emailId,
            orgCode: loginDetails.orgCode
        });
        this.form.get('username').disable();
        this.form.get('orgCode').disable();

    }

    backToOrgAuth(){
        this.showOrg = true;
        this.pageLogin = false;
    }

    setCookiesDetails(){
        const userData = this.cookieStoreService.getEnCookie(COOKIE_NAMES.userOrgData);
        const userOrgData = JSON.parse(userData);
        if(userData){
            this.initialLoginSetup.patchValue({
                emailId: userOrgData.emailId,
                organizationCode: userOrgData.organizationId,
                rememberMe: true
            });
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}


